module.exports = __webpack_public_path__ + "img/close.64b7d31d.svg";